import React from "react";
import "./Categories.css";

function Categories() {
  return (
    <div className="categories">
      <p className="categories__text">Development</p>
      <p className="categories__text">Business</p>
      <p className="categories__text">Finance & Accounting</p>
      <p className="categories__text">Finance & Accounting</p>
      <p className="categories__text">IT & Software</p>
      <p className="categories__text">Office Productivity</p>
      <p className="categories__text">Personal Development</p>
      <p className="categories__text">Design</p>
      <p className="categories__text">Marketing</p>
      <p className="categories__text">Health & Fitness</p>
      <p className="categories__text">Music</p>
    </div>
  );
}

export default Categories;
